<template>
  <sub-page :title="title">
    <div class="list-page">
      <div class="list-item" v-for="(item, idx) in items" :key="idx" @click="goToQuery(item)">
        <span class="item-text">{{ item.title }}</span>
        <svg viewBox="0 0 24 24" class="arrow-icon">
          <path d="M9 18 L15 12 L9 6" fill="none" stroke="#c8c9cc" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'RightsRecordPrint',
  components: { SubPage },
  data() {
    return {
      title: '个人权益记录查询打印',
      items: [
        { title: '社会保险个人权益（城镇职工）' },
        { title: '社会保险个人权益（城乡居民）' },
        { title: '江苏省企业职工基本养老保险权益记录单(参保人员)' },
        { title: '江苏省社会保险权益记录单(参保人员)' },
        { title: '江苏省企业职工基本养老保险权益记录单(离退休人员)', directResult: true },
        { title: '江苏省企业职工基本养老保险权益记录单（病残津贴人员）', directResult: true },
        { title: '职业年金个人权益记录单' },
        { title: '机关事业单位养老保险个人账户权益记录单' }
      ]
    }
  },
  methods: {
    goToQuery(item) {
      // 标记 directResult 的条目跳过查询页，直达结果页
      if (item.directResult) {
        this.$router.push({
          path: '/rights-record-result',
          query: { type: item.title }
        })
        return
      }
      this.$router.push({
        path: '/rights-record-query',
        query: { type: item.title }
      })
    }
  }
}
</script>

<style scoped>
.list-page {
  background: #F3F8FB;
  min-height: 100%;
}
.list-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: calc(40 * var(--w)) calc(32 * var(--w));
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
}
.list-item:last-child {
  border-bottom: none;
}
.item-text {
  flex: 1;
  font-size: calc(42 * var(--w));
  color: #323233;
  line-height: 1.5;
  margin-right: calc(20 * var(--w));
}
.arrow-icon {
  width: calc(32 * var(--w));
  height: calc(32 * var(--w));
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/RightsRecordPrint.vue